"use client";

import { withFallback } from "../with-fallback";

// Options type is automatically inferred from "balance-element"
export const BalanceElement = withFallback({
	displayName: "BalanceElement",
	type: "balance-element",
} as const);
